import SeoHead from '../../components/feature/SeoHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Sabadell – Compra de Coches',
  description: 'Compramos coches en Sabadell al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Sabadell', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Sabadell' },
  url: `${siteUrl}/desguace-sabadell`,
};

export default function DesguaceSabadellPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Sabadell | Vende tu Coche al Mejor Precio | Recogida Gratis"
        description="Desguace en Sabadell. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en todo Sabadell y Vallès Occidental. Pago inmediato."
        keywords="desguace Sabadell, vender coche Sabadell, compra coches Sabadell, coche siniestrado Sabadell, desguace Vallès Occidental"
        canonical={`${siteUrl}/desguace-sabadell`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Desguace en Sabadell
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Compramos tu coche en Sabadell y el Vallès Occidental. Recogida gratuita y pago inmediato garantizado.
            </p>
          </div>
        </section>

        {/* Contenido Principal */}
        <article className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong>Desguace Sabadell</strong> es tu mejor opción para vender tu coche en la capital del Vallès Occidental. Ofrecemos servicio de recogida gratuita en toda la ciudad y alrededores, con el mejor precio del mercado por tu vehículo.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Con más de <strong>15 años de experiencia</strong> comprando coches en Sabadell, conocemos perfectamente la zona y ofrecemos un servicio profesional y de confianza. No importa el estado de tu coche, siempre hacemos una oferta justa.
              </p>
            </div>

            {/* Zonas de Sabadell */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Zonas de Sabadell Donde Recogemos
              </h2>
              
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                {['Centre', 'Gràcia', 'La Creu Alta', 'Can Puiggener', 'Torre-romeu', 'Can Rull', 'Espronceda', 'Can Llong', 'Sant Oleguer', 'Cifuentes', 'Les Termes', 'Can Feu'].map((zona) => (
                  <div key={zona} className="bg-[#f8f9fa] p-4 rounded-lg text-center">
                    <i className="ri-map-pin-line text-[#ff6b35] text-xl mb-2"></i>
                    <p className="text-sm font-medium text-[#1a2332]">{zona}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Ventajas */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                ¿Por Qué Vender tu Coche con Nosotros en Sabadell?
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-map-pin-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Cobertura Total</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Recogemos en todo Sabadell y municipios cercanos del Vallès Occidental.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Rapidez</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Tasación en menos de 24 horas y recogida en 48-72 horas.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-money-euro-circle-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Mejor Precio</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Ofrecemos las mejores valoraciones de Sabadell y alrededores.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Proceso Legal</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Gestionamos toda la documentación: baja, certificado de destrucción, etc.
                  </p>
                </div>
              </div>
            </section>

            {/* Tipos de coches */}
            <section className="mb-16 bg-[#f8f9fa] p-8 rounded-2xl">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Coches que Compramos en Sabadell
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Siniestrados:</strong> Vehículos con daños por accidente de cualquier tipo.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Averiados:</strong> Averías mecánicas, eléctricas o de motor.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Sin ITV:</strong> Coches con ITV caducada o que no pueden pasarla.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Viejos:</strong> Vehículos antiguos o con muchos kilómetros.</p>
                </div>
              </div>
            </section>

            {/* CTA Final */}
            <section className="bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
              <h2 className="text-4xl font-black mb-4">
                Vende tu Coche en Sabadell Hoy
              </h2>
              <p className="text-xl mb-8 text-white/90">
                Tasación gratuita y sin compromiso
              </p>
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20valorar%20mi%20coche%20en%20Sabadell" 
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center px-10 py-5 bg-[#25d366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3 text-2xl"></i>
                WhatsApp 932 932 913
              </a>
            </section>

          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
